import { QueryClientProvider } from '@tanstack/react-query'
import { useState, type ReactNode } from 'react'

import { useTheme } from '@/shared/hooks/use-theme'
import { Toaster } from '@/shared/ui/sonner'
import { createQueryClient } from './query-client'

export function Providers({ children }: { children: ReactNode }) {
  // Built once per mount rather than per render, so the cache survives a
  // re-render and StrictMode's double-invoke does not discard it.
  const [queryClient] = useState(createQueryClient)
  // Here rather than in the shell: `/login` and the signed-out page are outside
  // it, and a theme that only applies once you are in is a theme that flashes.
  useTheme()

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <Toaster richColors closeButton />
    </QueryClientProvider>
  )
}
